import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { ReportService } from '../../pages/report/report.service';
import { RequestVoidService } from '../../pages/request-void/request-void.service';

@Component({
  selector: 'app-void-transaction',
  templateUrl: './void-transaction.component.html',
  styleUrls: ['./void-transaction.component.scss'],
})
export class VoidTransactionComponent implements OnInit {

  @Input() token: any;
  reasonType:any;
  replacementReceipt:any='0';
  replacementReceiptId:any=0;
  itemInReplacementReceipt:any=[];
  @Input() currentReceipt:any='';
  dataCurrentReceipt:any=[];
  itemInCurrentReceipt:any=[];
  closeMessage:any='';
  voidReason:any=[];
  currentId=0;
  title :any= 'Void Transaction';
  currentReceiptDetail:any=[];
  compareResult:any ='';
  enoughPoint:boolean=true;
  currentPoint:number=0;
  inPoint:number=0;
  customerId:any=0;
  constructor(
    private reportService:ReportService,
    private requestVoidService:RequestVoidService,
    private modalController : ModalController,
    private toastCtrl:ToastController,
    private utilService:UtilService){}

  ngOnInit() {    
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      
      this.reportService.getMasterVoidReason({ "token": this.token })
      .subscribe((response2) => {
        this.voidReason=response2.data;
        this.reportService.getSalesByReceiptNumber({ "token": this.token }, this.currentReceipt)
        .subscribe((response) => {
          this.utilService.loadingDismiss();
          if (response.status.code == 200) {
            this.currentReceiptDetail = response.results.sales_data;
            this.dataCurrentReceipt = response;
            this.itemInCurrentReceipt= response.results.customer_item;
            this.currentId = this.currentReceiptDetail.id;
            this.customerId =response.results.sales_data.customer_id;
            
            let customer_data =  response.results.customer_data;
            let point_mutation_data =  response.results.point_mutation_data;
            this.currentPoint = Number(customer_data.current_point);
            this.inPoint = Number(point_mutation_data.in_point);
              if(this.inPoint > 0 && this.currentPoint<this.inPoint){
              this.enoughPoint =false;
            }
          }
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Sales!' }).then(t => t.present());
        });}, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Sales!' }).then(t => t.present());
        });
    });
  }

  async dismissModal() {
    let data = {
        'close_message':this.closeMessage,
        'reason_type': this.reasonType,
        'replacement_receipt': this.replacementReceipt,
        'replacement_receipt_id': this.replacementReceiptId
      };
    await this.modalController.dismiss(data);
  }
  isSameItems(current: any[], replacement: any[]): boolean {
    if (current.length !== replacement.length) {
      return false; // jumlah item tidak sama
    }
    // Ubah array menjadi map { item_id: qty } untuk memudahkan pencocokan
    const toMap = (arr: any[]) => {
      return arr.reduce((map, item) => {
        map[item.item_id] = item.item_qty;
        return map;
      }, {} as Record<string, string>);
    };

    const currentMap = toMap(current);
    const replacementMap = toMap(replacement);

    // Bandingkan semua item_id dan qty
    for (const itemId in currentMap) {
      if (
        !(itemId in replacementMap) || 
        currentMap[itemId] !== replacementMap[itemId]
      ) {
        return false;
      }
    }
    return true;
  }

  isDobelReceipt(dobelReceipt:any){
    this.compareResult='';
    const keysToCompare = [
      'cashier_id',
      'user_id',
      'counter_id',
      'warehouse_id',
      'customer_id',
      'trans_date',
      'trans_time',
      'total_item',
      'total_value',
      'total_payment',
      'discount',
      'change',
      'cash',
      'credit_card',
      'debit_card',
      'transfer',
      'voucher',
      'member_point',
    ];
    const differentFields: string[] = [];

    for (const key of keysToCompare) {
      if (this.currentReceiptDetail[key] !== dobelReceipt[key]) {
        differentFields.push(key);
      }
    }

    if (differentFields.length === 0) {
      return true;
    } else {
      this.compareResult = 'Struk tidak dobel. Perbedaan : ' + differentFields.join(', ');
      return false;
    }
  }

  validation(){
    this.replacementReceiptId = 0;
    let reason = this.selectedReason ? this.selectedReason.reason.toLowerCase() :'';
    if(reason === 'other' || reason === 'lainnya'){
      this.closeMessage ='';
      if(this.currentReceipt.trim()==this.replacementReceipt.trim()){
          this.toastCtrl.create({ duration: 2000, message: 'No Struk Pengganti tidak boleh sama dengan struk yang divoid' }).then(t => t.present());
      }
      else{
        //cari dulu struk pengganti ini pernah dipakai untuk void transaksi lain ga
        this.itemInReplacementReceipt = [];
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          this.reportService.getSalesByReceiptNumber({ "token": this.token }, this.replacementReceipt)
          .subscribe((response) => {
            this.utilService.loadingDismiss();
            if (response.status.code == 200) {
              this.itemInReplacementReceipt= response.results.customer_item;
              let replacement = response.results.replacement ? response.results.replacement : [];
              if(response.results.sales_data.id < this.currentId){
                this.toastCtrl.create({ duration: 2000, message: 'Struk Pengganti tidak boleh lebih lama dari dengan struk yang divoid' }).then(t => t.present());      
              }
              else if(response.results.sales_data.status=='2'){
                this.toastCtrl.create({ duration: 2000, message: 'Struk Pengganti tidak valid karena statusnya void' }).then(t => t.present());
              }
              else if(this.customerId!=0 && response.results.sales_data.customer_id!=this.customerId){
                this.toastCtrl.create({ duration: 2000, message: 'Struk Pengganti tidak valid berbeda member' }).then(t => t.present());
              }
              else if(replacement.length>0){
                this.toastCtrl.create({ duration: 2000, message: 'Struk Pengganti tidak valid karena sudah dipakai sebagai struk pengganti transaksi lain' }).then(t => t.present());
              }
              else{
                if (this.isSameItems(this.itemInCurrentReceipt, this.itemInReplacementReceipt)) {
                  this.closeMessage='valid';
                  this.replacementReceiptId=response.results.sales_data.id;
                  this.dismissModal();
                } else {
                  this.toastCtrl.create({ duration: 2000, message: 'Ada perbedaan item atau qty barang customer' }).then(t => t.present());
                }
              }
            }
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Sales!' }).then(t => t.present());
          });
        });
      }
    }
    else  if(reason === 'double transactions' || reason === 'dobel transaksi'){
      this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        //cari apakah ada no struk yg sama dengan struk ini,cek receipt no yg status nya 1 dan id beda dgn id ini
        let options = {
            "token": this.token,
            "id":this.currentId
        }
        this.requestVoidService.checkBeforeVoid(options)
        .subscribe((response) => {
          this.utilService.loadingDismiss();
          if (response.status.code == 200) {
            let totalDuplicate= Number(response.results.total_duplicate);
            if(totalDuplicate==0){
              this.toastCtrl.create({ duration: 2000, message: 'Tidak ada data struk yang duplikat' }).then(t => t.present());      
            }
            else{
              this.closeMessage='valid';
              this.replacementReceiptId=0;;
              this.dismissModal();
            }
          }
        }, () => {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Sales!' }).then(t => t.present());
        });
      });
      
    }
    else   if(reason === ''){
      this.toastCtrl.create({ duration: 2000, message: 'Mohon pilih Alasan' }).then(t => t.present());
    }
    else{
      this.closeMessage='valid';
      this.dismissModal();
    }
  }
  get selectedReason(): any {
    return this.voidReason.find(v => v.id === this.reasonType);
  }

onFocusJumlah() {
  if (this.replacementReceipt === 0 || this.replacementReceipt === '0') {
    this.replacementReceipt = '';
  }
}

onBlurJumlah() {
  if (this.replacementReceipt === '' || this.replacementReceipt === null || isNaN(this.replacementReceipt)) {
    this.replacementReceipt = 0;
  }
}
}

